import { observer } from 'mobx-react';
import type { MouseEventHandler, MouseEvent, ReactNode, FC } from 'react';
import ProductBuyBtnSubscribe from './ProductBuyBtnSubscribe';
import ProductBuyBtns from './ProductBuyBtns';
import { useStores } from '@root/src/stores';
import './index.scss';

export interface ProductBuyBtnProps {
  productId: string;
  available: boolean;
  isHideSubscribeBtn?: boolean;
  MobileComp: ReactNode;
  showOnlyPrice?: boolean;
  isDesktop?: boolean;
  isShowLongBuyBtn?: boolean;
  isPreOrder?: string;
  mutateOrder?: (e: MouseEvent, method: 'plus' | 'minus') => void;
  mutateOrderQuantity?: number;
  callback?: () => void;
  isDigital?: boolean;
  onAddToOrderFirst?: () => void;
}

const ProductBuyBtn: FC<ProductBuyBtnProps> = observer(
  ({
    mutateOrder,
    mutateOrderQuantity,
    productId,
    available,
    MobileComp,
    isDesktop,
    isShowLongBuyBtn,
    isPreOrder,
    isDigital,
    isHideSubscribeBtn,
    onAddToOrderFirst,
    callback: callbackProps
  }) => {
    const { cartStore, modalsStore } = useStores();
    const { productsAmount, updateCart, changeProductsAmount } = cartStore;
    const { openDigitalModal } = modalsStore;

    const updateCartFunc = (number: number): void => {
      changeProductsAmount(number, Number(productId));
      updateCart(Number(productId), productsAmount[productId]);
    };

    const addProductToCart: MouseEventHandler = e => {
      e.preventDefault();
      e.stopPropagation();
      if (isDigital) {
        openDigitalModal(productId);
        return;
      }
      if (!productsAmount[productId]) {
        onAddToOrderFirst?.();
      }
      updateCartFunc(1);
    };

    const decreaseProductInCart: MouseEventHandler = e => {
      e.preventDefault();
      e.stopPropagation();
      updateCartFunc(-1);
    };

    const productCount =
      mutateOrderQuantity || cartStore.productsAmount?.[productId];

    const addProductToCartFunc = mutateOrder
      ? (e: MouseEvent) => {
          mutateOrder(e, 'plus');
        }
      : addProductToCart;

    const decreaseProductInCartFunc = mutateOrder
      ? (e: MouseEvent) => {
          mutateOrder(e, 'minus');
        }
      : decreaseProductInCart;

    const isShowMinus = mutateOrder
      ? !!(mutateOrderQuantity && mutateOrderQuantity > 1)
      : true;

    if (available) {
      return (
        <ProductBuyBtns
          isShowMinus={isShowMinus}
          isShowLongBuyBtn={isShowLongBuyBtn}
          isDesktop={isDesktop}
          MobileComp={MobileComp}
          productCount={productCount}
          addProductToCart={(e: MouseEvent) => {
            addProductToCartFunc(e);
          }}
          decreaseProductInCart={(e: MouseEvent) => {
            decreaseProductInCartFunc(e);
          }}
          isPreOrder={isPreOrder}
          isDigital={isDigital}
        />
      );
    }
    if (!isHideSubscribeBtn) {
      return (
        <ProductBuyBtnSubscribe
          productId={+productId}
          callback={callbackProps}
        />
      );
    }
    return null;
  }
);

export default ProductBuyBtn;
